<template>
  <div class="mask" v-if="dialogVisible">
    <div class="dialog">
      <div class="close-btn" @click="close"></div>
      <div class="title">{{ title }}</div>
      <div class="content">
        <slot name="content"></slot>
        <div class="btn-box" v-if="button" @click="confirm">
          <slot name="btn">
            <div class="confirm-btn"></div>
          </slot>
        </div>
        <slot name="tips"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PcDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    button: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      dialogVisible: false,
    }
  },
  watch: {
    visible: function (val) {
      this.dialogVisible = val
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    confirm() {
      this.$emit('confirm')
    },
  }
}
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .7);

  .dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 568px;
    height: 660px;
    background: url('~@/assets/img/pc/dialog_bg.png') no-repeat;
  }

  .close-btn {
    position: absolute;
    top: 13px;
    right: -48px;
    width: 54px;
    height: 54px;
    background: url('~@/assets/img/pc/dialog_close_btn.png') no-repeat;
    cursor: pointer;
  }

  .title {
    position: absolute;
    top: 60px;
    left: 50%;
    transform: translateX(-50%);
    width: 419px;
    text-align: center;
    font-size: 33px;
    font-family: Noto Serif SC;
    font-weight: bold;
    color: #9f5e48;
  }

  .content {
    position: absolute;
    top: 170px;
    left: 50%;
    transform: translateX(-50%);
    width: 419px;
  }

  .btn-box {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    display: inline-block;
  }

  .confirm-btn {
    margin: 0 auto;
    width: 188px;
    height: 53px;
    background: url('~@/assets/img/pc/dialog_confirm_btn.png') no-repeat;
    cursor: pointer;

    &:hover {
      background-position: 0 -53px;
    }
  }
}
</style>